{
  "pt-PT": {
    "model": {
      "profile": {
        "id": "ID do utilizador.",
        "userName": "Nome de utilizador",
        "email": "Endereço de e-mail",
        "emailConfirmed": "Email confirmado",
        "phoneNumber": "Número de telefone",
        "phoneNumberConfirmed": "Número de telefone confirmado.",
        "twoFactorEnabled": "Autenticação de dois fatores ativada.",
        "lockoutEnd": "Fim do período de bloqueio.",
        "lockoutEnabled": "Bloqueio ativado.",
        "accessFailedCount": "Número de tentativas de acesso falhadas.",
        "firstName": "Primeiro nome",
        "lastName": "Apelido",
        "picture": "Imagem do avatar",
        "organisationName": "Organização",
        "name": "Nome",
        "roles": "Funções"
      }
    },
    "profileManager": {
      "column": {
        "emailConfirmed": "Confirmado"
      },
      "action": {
        "resetPassword.tooltip": "Enviar instruções de redefinição de palavra-passe para o utilizador por e-mail."
      },
      "message": {
        "resetPassword.success": "Foi enviado um e-mail ao utilizador com as instruções para repor a sua palavra-passe."
      }
    }
  }
}